import { LargeNumber, NumberContainer, NumberText, NumberTextContainer } from './styled';

interface Props {
	itemNumber: number;
	itemHeader: string;
	itemSubHeader: string;
	color: string;
	dataTestId?: string;
}

export const UploadStatItem = ({
	itemHeader,
	itemNumber,
	itemSubHeader,
	color,
	dataTestId,
}: Props) => {
	return (
		<NumberContainer>
			<LargeNumber $fontColor={color} data-testid={dataTestId}>
				{itemNumber}
			</LargeNumber>
			<NumberTextContainer>
				<NumberText $fontColor={color} $fontWeight={600}>
					{itemHeader}
				</NumberText>
				<NumberText $fontColor={color} $fontWeight={400}>
					{itemSubHeader}
				</NumberText>
			</NumberTextContainer>
		</NumberContainer>
	);
};
